import React, { createContext, useContext, useRef } from 'react'

// Default to { current: null } so useResizeObserver in ResponsiveTable doesn't crash
// when DmcResponsiveTable is rendered outside of RoleIndicatorRefProvider (e.g. in tests).
export const RoleIndicatorRefContext = createContext({ current: null })

export function RoleIndicatorRefProvider({ children }) {
  const roleIndicatorRef = useRef(null)
  return (
    <RoleIndicatorRefContext.Provider value={roleIndicatorRef}>
      {/*
        Sentinel div whose rendered height tracks --role-indicator-height, the CSS variable
        published by @fs/zion-role-indicator on its wrapper (an ancestor in the DOM).
        ResponsiveTable's stickyBelowRef uses ResizeObserver on this element, which fires
        whenever the banner appears, disappears, or changes height.
      */}
      <div
        ref={roleIndicatorRef}
        style={{
          position: 'sticky',
          top: 0,
          height: 'var(--role-indicator-height, 0px)',
          pointerEvents: 'none',
          visibility: 'hidden',
          zIndex: -1,
        }}
      />
      {children}
    </RoleIndicatorRefContext.Provider>
  )
}

export function useRoleIndicatorRef() {
  return useContext(RoleIndicatorRefContext)
}
